/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */

import { clearImageVariantCache } from "./imageVariants";
import { clearUnsettledRequestMarkers } from "./unsettledRequestMarkers";
import { clearRenewalDismissals } from "./renewalDismissals";
import { clearAccessNoticeDismissals } from "./accessNoticeDismissals";
import { clearAccessEndedMarker } from "./accessEndedMarker";

/**
 * Drop the browser state one signed-in person leaves behind, so the next
 * person on the same machine starts clean: tokened image URLs, a gym's
 * unfinished-settlement markers, dismissed renewal and access notices, and the
 * "your access to <Gym> ended" marker (which outlives a forced sign-out by
 * design). Every path that switches the signed-in user runs this.
 */
export const clearPerUserClientState = (): void => {
  clearImageVariantCache();
  clearUnsettledRequestMarkers();
  clearRenewalDismissals();
  clearAccessNoticeDismissals();
  clearAccessEndedMarker();
};
